module.exports = __webpack_public_path__ + "img/security_ticket.741a0adb.png";